export default function CalloutBox(props) {
  return (
    <div className="callout">

      {/* Top Section */}
      <div className="callout__top">

        <div className="callout__badge">

          {/* Static SVG */}
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="tag-icon"
          >
            <path
              d="M0.75 8.62869V2.25C0.75 1.42156 1.42156 0.75 2.25 0.75H8.62869C9.02652 0.750002 9.40804 0.908039 9.68935 1.18934L16.3107 7.81066C16.8964 8.39644 16.8964 9.34619 16.3107 9.93197L9.93197 16.3107C9.34619 16.8964 8.39644 16.8964 7.81066 16.3107L1.18934 9.68935C0.908039 0.908039 0.750002 9.02652 0.75 8.62869Z"
              stroke="white"
              strokeWidth="1.5"
            />
          </svg>

          {props.badgeText && (
            <div className="callout__badge-text">
              {props.badgeText}
            </div>
          )}

        </div>

        {props.codeValue && (
          <div className="callout__code">
            {props.codePrefix && (
              <span className="callout__code-prefix">
                {props.codePrefix}
              </span>
            )}
            <span className="callout__code-value">
              {" "}{props.codeValue}
            </span>
          </div>
        )}

      </div>

      {/* CTA Section */}
      <div className="callout__cta">

        {props.ctaText && (
          <div className="callout__cta-label">
            {props.ctaText}
          </div>
        )}

        {props.buttonText && props.buttonLink && (
          <a
            href={props.buttonLink}
            className="button-secondary"
          >
            <p className="button-secondary__text">
              {props.buttonText}
            </p>
          </a>
        )}

      </div>

    </div>
  );
}

